import { ActionCard, Assessment, Question, Section } from '@playbooks/core/src/interfaces/ActionCard'
import { sectionTypes } from '@playbooks/core/src/constants'

import { checkVisibility } from './actionCard'

function enableSeparator(data: ActionCard): void {
  if (!data.touchedSeparators) data.touchedSeparators = []

  const idSet = new Set<number>()

  for (const sec of data.sections) {
    if (sec.type === sectionTypes.SEPARATOR) continue

    const isSecShown = checkVisibility(sec, data)

    if (isSecShown) {
      const id = getEnabledSeparatorId(sec)

      if (id) {
        if (!data.touchedSeparators?.includes(id)) {
          data.touchedSeparators.push(id)
        }

        idSet.add(id)
      }
    }
  }

  data.enabledSeparators = Array.from(idSet)

  const notEnabledSeparators = data.sections.flatMap(sec => {
    const isSeparator = sec.type === sectionTypes.SEPARATOR

    if (!data.enabledSeparators?.includes(isSeparator ? sec.id : sec.idOfSep!)) {
      return isSeparator ? sec.id : sec.idOfSep
    }

    return []
  })

  notEnabledSeparators.forEach(notEnSepId => {
    data.touchedSeparators = data.touchedSeparators?.filter(tid => tid !== notEnSepId)
  })

  data.lastActiveSeparator = data.touchedSeparators[data.touchedSeparators.length - 1]!
}

function getEnabledSeparatorId(sec: Section) {
  const isSomeElementFilled = sec.elements?.some(element => {
    const assessment = element as Assessment
    const question = element as Question

    const isSomeResponseChecked = assessment.responses?.some(resp => !!resp.checked)
    const isSomeAnswerFilled = !!(typeof question.value === 'number' ? question.value.toString() : question.value)

    return isSomeResponseChecked || isSomeAnswerFilled
  })

  if (isSomeElementFilled) {
    return sec.idOfSep
  }

  if (!!sec.value) {
    return sec.idOfSep
  }

  return null
}

export default enableSeparator
